var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.305,
    height: 51.332,
    viewBox: "0 0 177.305 51.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3725.664 2046.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4209.674 -1730.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4244.674 -1730.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4279.674 -1730.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4313.674 -1730.735)",
    fill: "#7fc4fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4348.674 -1730.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4365.674 -1741.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4330.674 -1741.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4296.674 -1741.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4261.674 -1741.735)",
    fill: "#7fc4fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4226.674 -1741.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4209.674 -1708.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4244.674 -1708.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4279.674 -1708.735)",
    fill: "#7fc4fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4313.674 -1708.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4348.674 -1708.735)",
    fill: "#7fc4fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4365.674 -1719.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4330.674 -1719.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4296.674 -1719.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4261.674 -1719.735)",
    fill: "#bce0fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-483.432-295.569l5.038-8.631h9.912l5.194,8.631-5.194,8.7h-9.912Z",
    transform: "translate(4226.674 -1719.735)",
    fill: "#7fc4fd",
    stroke: "#2699fb",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan3);
export default __webpack_public_path__ + "static/media/plan-3.057c03dc99e62fcc637fb0097529ec46.svg";
export { ForwardRef as ReactComponent };